module.exports = __webpack_public_path__ + "static/media/smallgiants.69d2d82a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/smallgiants.webp
// module id = 212
// module chunks = 0